export default {
    path: '/binding',
    meta: {
        title: '绑定身份',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/binding`),
}


// WEBPACK FOOTER //
// ./src/views/binding/router.js